function isMXStaging(): boolean {
    try {
        return (
            window.location.hostname.includes('hb-mx-staging-') ||
            window.location.hostname.includes('hb-app-staging-')
        );
    } catch (e) {
        return false;
    }
}

function isMXProduction(): boolean {
    try {
        return window.location.hostname === 'app.honeybook.com';
    } catch (e) {
        return false;
    }
}

function isMXDevelopment(): boolean {
    try {
        // CX environments have company name as a subdomain (company.localhost:7100)
        // Also include localhost:3030 as an MX development environment
        return (
            window.location.host === 'localhost:7100' ||
            window.location.host === 'localhost:3030'
        );
    } catch (e) {
        return false;
    }
}

function isMXEnvironment(): boolean {
    return isMXDevelopment() || isMXStaging() || isMXProduction();
}

export function getCurrentAppScope() {
    return isMXEnvironment() ? 'mx' : 'cx';
}

export function isProduction(): boolean {
    return !!(window as any)?.isProduction;
}

export function isHbDevServer() {
    try {
        return process.env.HB_DEV_SERVER === 'true';
    } catch (e) {
        return false;
    }
}
